import React, { useEffect, useState } from 'react';
import { Heading } from '@podiumhq/design-system';

import Notification from 'components/Notification';
import useChangePage from 'hooks/useChangePage';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';
import { TRIAL_URL } from 'routes/constants';
import { TRIAL_PAYMENT_STEP } from 'screens/Trials/constants';

import { ACCOUNT_BUTTON_LABEL, ACCOUNT_FORM_TITLE } from '../../constants';
import useValidateAccount from '../../hooks/useValidateAccount';
import { trialTitleStyles } from '../../styles';

import TrialAccountSection from './TrialAccountSection';

const TrialAccountInfo = () => {
  const changePage = useChangePage();
  const trackEvent = useTrackAmplitudeEvent('trials.accountInfo.visited');
  const hasValidAccountFields = useValidateAccount(true);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = () => {
    trackEvent('trials.accountInfo.nextClicked');
    setIsSubmitting(true);

    hasValidAccountFields()
      .then((isValid) => {
        if (isValid) {
          changePage(`${TRIAL_URL}/${TRIAL_PAYMENT_STEP}`);
        }
      })
      .catch((error) => {
        trackEvent('trials.accountInfo.error', {
          error: JSON.stringify(error),
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  useEffect(() => {
    return () => setIsSubmitting(false);
  }, []);

  return (
    <>
      <Heading {...trialTitleStyles}>{ACCOUNT_FORM_TITLE}</Heading>

      <Notification />

      <TrialAccountSection
        buttonLabel={ACCOUNT_BUTTON_LABEL}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default TrialAccountInfo;
